import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

interface FindReplaceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFindNext: (query: string) => void;
  onReplace: (query: string, replace: string) => void;
  onReplaceAll: (query: string, replace: string) => void;
}

export const FindReplaceModal: React.FC<FindReplaceModalProps> = ({
  isOpen,
  onClose,
  onFindNext,
  onReplace,
  onReplaceAll,
}) => {
  const [findQuery, setFindQuery] = useState('');
  const [replaceQuery, setReplaceQuery] = useState('');

  const handleFindNext = () => {
    if (findQuery) {
      onFindNext(findQuery);
    }
  };

  const handleReplace = () => {
    if (findQuery) {
      onReplace(findQuery, replaceQuery);
    }
  };

  const handleReplaceAll = () => {
    if (findQuery) {
      onReplaceAll(findQuery, replaceQuery);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Find and Replace</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="find-input">
              Find
            </Label>
            <Input
              id="find-input"
              value={findQuery}
              onChange={(e) => setFindQuery(e.target.value)}
              placeholder="Text to find"
              autoComplete="off"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="replace-input">
              Replace with
            </Label>
            <Input
              id="replace-input"
              value={replaceQuery}
              onChange={(e) => setReplaceQuery(e.target.value)}
              placeholder="Replacement text"
              autoComplete="off"
            />
          </div>
        </div>
        <DialogFooter className="flex-col-reverse sm:flex-row sm:justify-between gap-2">
          <Button type="button" variant="outline" onClick={handleFindNext} disabled={!findQuery}>
              Find Next
          </Button>
          <div className='flex justify-end gap-2'>
              <Button type="button" onClick={handleReplace} disabled={!findQuery}>
                  Replace
              </Button>
              <Button type="button" onClick={handleReplaceAll} disabled={!findQuery}>
                  Replace All
              </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};